"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = parseCatalogData;

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectSpread"));

require("core-js/modules/es6.function.name");

var _categoryConfig = _interopRequireDefault(require("./../../categoryConfig"));

var _uigDeviceUtil = _interopRequireDefault(require("@sfly/uig-device-util"));

var _constants = require("../../constants");

var isDesktop = _uigDeviceUtil.default.desktop();

var parentCategoryJSON = function parentCategoryJSON(code, name) {
  return {
    code: code,
    name: name
  };
};

var sortByRank = function sortByRank(data) {
  return data.sort(function (a, b) {
    if (typeof a.rank !== 'number') {
      a.rank = 9999;
    }

    if (typeof b.rank !== 'number') {
      b.rank = 9999;
    }

    return a.rank - b.rank;
  });
};
/**
 * @description
 * Evaluates if a category is to be hidden or the sub categories for a category are to be hidden.
 * @param {Object[]} node - List of categories or Subcategories
 * @param {String} type - categories or sub categories to hide
 * @returns {Boolean} hide - returns TRUE if the sub-categories for a category are to be hidden or if a category is to be hidden from the list or returns FALSE
 */


var isHidden = function isHidden(node, type) {
  var isHidden = false;
  var hiddenList = type !== 'subCategories' ? _categoryConfig.default.hideCategories : _categoryConfig.default.hideSubCategories;
  hiddenList.forEach(function (hiddenCategory) {
    if (node === hiddenCategory) {
      isHidden = true;
    }
  });
  return isHidden;
};
/**
 * @description
 * Evaluates if a item is to be hidden or not based on various flags like `hidden`, `disabledOnMobile` or in the config file
 * @param {Object[]} node - Category or Sub Category item
 * @returns {Boolean} hide - returns TRUE if a category or sub-category needs to be hidden.
 */


var hideItem = function hideItem(categoryItem) {
  return !isDesktop && categoryItem.disabledOnMobile || categoryItem.hidden || isHidden(categoryItem.code, 'category');
};
/**
 * @description
 * Evaluates if a each sub categories is not visible or not. This will be used to add hasSubcategory property to category object.
 * @param {Object[]} node - List of subcategories
 * @returns {Boolean} isFound - returns TRUE if atleast one in the list is visible.
 */


var hasSubCat = function hasSubCat(subCategories) {
  var isFound = false;
  subCategories.forEach(function (category) {
    if (category.hidden === undefined || !hideItem(category)) {
      isFound = true;
    }
  });
  return isFound;
};

var getSubCategoriesList = function getSubCategoriesList(category, parentCategory) {
  var subCategoriesList = [];
  var name = category.name,
      mobileName = category.mobileName,
      code = category.code,
      url = category.url,
      subCategories = category.subCategories;
  sortByRank(subCategories);
  subCategories.forEach(function (subCategory) {
    var name = subCategory.name,
        mobileName = subCategory.mobileName,
        url = subCategory.url,
        newCategoryTagEnabled = subCategory.newCategoryTagEnabled;

    if (!hideItem(subCategory)) {
      var hasSubCategories = false;

      if (!isHidden(subCategory.code, 'subCategories') && subCategory.subCategories && subCategory.subCategories.length > 0) {
        hasSubCategories = hasSubCat(subCategory.subCategories);
      }

      var _code = "".concat(subCategory.code, "_").concat(parentCategory.code);

      subCategoriesList.push({
        name: name,
        mobileName: mobileName,
        code: _code,
        url: url,
        hasSubCategories: hasSubCategories,
        parentCategory: parentCategory,
        newCategoryTagEnabled: newCategoryTagEnabled ? newCategoryTagEnabled : false
      });
    }
  });

  if (subCategoriesList.length > 0 && parentCategory.code !== _categoryConfig.default.HOME_ID) {
    subCategoriesList.splice(0, 0, {
      name: "See All ".concat(mobileName || name),
      code: code,
      url: url,
      hasSubCategories: false,
      newCategoryTagEnabled: false
    });
  }

  return subCategoriesList;
};

var generateJSON = function generateJSON(responseData, parentCategory) {
  sortByRank(responseData);
  var categoryJSON = {};
  responseData.forEach(function (category) {
    if (!hideItem(category)) {
      var name = category.name,
          mobileName = category.mobileName,
          code = category.code,
          url = category.url,
          subCategories = category.subCategories,
          newCategoryTagEnabled = category.newCategoryTagEnabled;
      var hasSubCategories = false;
      var subcategoriesJSON = {};
      var subCategoriesList = [];
      var id = "".concat(category.code, "_").concat(parentCategory.code);

      if (code && !isHidden(code, 'subCategories') && subCategories && subCategories.length > 0) {
        subCategoriesList = getSubCategoriesList(category, parentCategoryJSON(id, category.mobileName || category.name));
        hasSubCategories = subCategoriesList.length > 0;
        subcategoriesJSON = generateJSON(subCategories, parentCategoryJSON(id, category.mobileName || category.name));
      }

      if (hasSubCategories) {
        categoryJSON[id] = {
          name: name,
          mobileName: mobileName,
          code: id,
          url: url,
          parentCategory: hasSubCategories ? parentCategory : undefined,
          hasSubCategories: hasSubCategories,
          subCategoriesList: subCategoriesList,
          newCategoryTagEnabled: newCategoryTagEnabled ? newCategoryTagEnabled : false
        };
        categoryJSON = (0, _objectSpread3.default)({}, subcategoriesJSON, {}, categoryJSON);
      }
    }
  });
  return categoryJSON;
};

function parseCatalogData(responseData, contextKey) {
  // responseData.push(
  //     contextKey === CONSTANTS.context.sfly
  //         ? CONSTANTS.HOME_LINKS.sfly
  //         : CONSTANTS.HOME_LINKS.tp,
  // );
  var categories = [{
    name: contextKey === _constants.BRANDS.TINYPRINTS ? 'Tinyprints' : 'Shutterfly',
    code: '0',
    url: '/',
    subCategories: responseData
  }];
  var categoriesJSON = generateJSON(categories, parentCategoryJSON('-1', 'Categories'));
  return categoriesJSON;
}